/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountGroupsPage} from '../models/AccountGroupsPage';
import type {Error} from '../models/Error';
import type {SortDirection} from '../models/SortDirection';

export interface GetAccountGroupsShortInfo$Request {
    accountId: number;
    sortDirection: SortDirection;
    searchByGroupName?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetAccountGroupsShortInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountGroupsShortInfoRequest = createAction<PayloadData<void, GetAccountGroupsShortInfo$Request>>('GET_ACCOUNT_GROUPS_SHORT_INFO__GET_ACCOUNT_GROUPS_SHORT_INFO__REQUEST');
export const getAccountGroupsShortInfoSuccess = createAction<PayloadData<AccountGroupsPage, GetAccountGroupsShortInfo$Request>>('GET_ACCOUNT_GROUPS_SHORT_INFO__GET_ACCOUNT_GROUPS_SHORT_INFO__SUCCESS');
export const getAccountGroupsShortInfoFailure = createAction<PayloadData<Error, GetAccountGroupsShortInfo$Request, true>>('GET_ACCOUNT_GROUPS_SHORT_INFO__GET_ACCOUNT_GROUPS_SHORT_INFO__FAILURE');

export const getAccountGroupsShortInfoActions = [
    getAccountGroupsShortInfoRequest,
    getAccountGroupsShortInfoSuccess,
    getAccountGroupsShortInfoFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SortDirection} meta.sortDirection
 * @param {string} [meta.searchByGroupName]
 * @param {number} [meta.pageNumber]
 * @param {number} [meta.pageSize]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountGroupsShortInfo = (meta: GetAccountGroupsShortInfo$Request, config?: GetAccountGroupsShortInfo$Config) => {
    const TRANSPORT_GET_PARAMS = {
        searchByGroupName: meta.searchByGroupName,
        sortDirection: meta.sortDirection,
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getAccountGroupsShortInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/groups`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

